import ApplicationController from './application'
import debounce from 'debounce'

export default class extends ApplicationController {
  connect() {
    this.submitForm = debounce(this.submitForm.bind(this), 600)
  }

  submitForm() {
    this.element.requestSubmit()
  }
}
